<div class="[grid-area:image] max-md:flex max-md:items-center max-md:justify-center">
  <app-results-table-row-image [isSpecial]="isSpecial()" [item]="item()" (openModal)="resultTableService.openDetailsModal(item())"/>
</div>
<div class="[grid-area:brand] max-md:py-0.5 whitespace-nowrap overflow-hidden text-ellipsis max-md:font-bold max-md:text-base max-md:pt-3">
  {{ item().brand }}
</div>
<div class="[grid-area:model] max-md:py-0.5">
  <span class="line-clamp-2" [title]="item().model">{{ item().model }}</span>
</div>
<div class="[grid-area:item-number] max-md:py-0.5">
  <div class="flex items-center gap-2">
    <div class="flex flex-no-wrap gap-1">
      @if (editItemVisible()) {
        <app-link (click)="editItem()" [disabled]="editItemDisabled()" [title]="access.getTitle('edit_item', 'Edit Item')">
          <app-icons icon="file-pen" svgClass=""/>
        </app-link>
      }

      @if (itemHistoryVisible()) {
        <app-link (click)="showItemHistory()" [disabled]="itemHistoryDisabled()" [title]="access.getTitle('view_item_history', 'Open Item History')">
          <app-icons icon="clock-rotate-left" svgClass=""/>
        </app-link>
      }
    </div>
    <div class="whitespace-nowrap text-ellipsis">{{ item().item_number }}</div>
  </div>
</div>
<div class="[grid-area:size] max-md:py-0.5">
  <span class="line-clamp-2" title="{{ item().size }} {{ featureString() }}">
    {{ item().size }}
    <span class="text-secondary">{{ featureString() }}</span>
  </span>
</div>
<div class="[grid-area:warranty] max-md:py-0.5 md:text-right">
  {{ mileageWarranty() }}
</div>
<div class="[grid-area:availability] max-md:py-0.5">
  <app-results-table-row-availability-badge [item]="item()"/>
</div>
<div class="[grid-area:price] max-md:py-0.5 md:text-right whitespace-nowrap max-md:text-sm max-md:flex max-md:items-center max-md:gap-1">
  <span class="md:hidden text-gray-500">Price: </span>
  <app-results-table-row-price [item]="item()"/>
</div>
<div class="[grid-area:actions] max-md:border-t max-md:border-default max-md:pt-2">
  <app-results-table-row-actions [item]="item()" (compareClicked)="resultTableService.addToCompare(item())" (quoteClicked)="resultTableService.addToQuote(item())"/>
</div>
